import { apiFGTS } from "../http/httpClient";

export const refuseTransaction = async (
  id: string,
  reason?: string,
): Promise<any> => {
  const response = await apiFGTS
    .delete<any>(`/transaction/${id}`, { data: { reason } })
    .catch((error) => {
      throw error.response.data;
    });
  return response.data;
};
